import { AxiosResponse } from "axios";
import { ListResponse } from "src/types/response";

import AuthService from "@services/authService";
import HttpService from "@services/httpService";
import RouteService from "@services/routeService";

import { unpackError } from "./helpers";

export const createStreamSession = async (workspaceId: number, type: "WebSocket" | "Http") => {
    try {
        const endpoint = await RouteService.getStreamRoute();
        const { data } = await HttpService.post<string, AxiosResponse<ListResponse<API.WebSocketSession>>>(
            endpoint + "stream",
            { workspaceId, types: [type] },
            { headers: { "content-type": "application/json" } },
        );

        if (data.list.length === 0) {
            throw new Error("No stream session found");
        }

        return data.list[0].model;
    } catch (error) {
        throw unpackError(error);
    }
};

export const getDeviceStreamLog = async (sessionId: string) => {
    const token = AuthService.getSession()?.access_token;
    const endpoint = await RouteService.getStreamRoute();
    try {
        return fetch(endpoint + "stream/" + sessionId, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Accept": "text/event-stream",
                "Connection": "keep-alive",
                "Keep-Alive": "timeout=5, max=1000",
            },
        });
    } catch (error) {
        throw unpackError(error);
    }
};
